import Vue from 'vue'
import Router from 'vue-router'

// import Home from '@/views/Home'
// import About from '@/views/About'
// import FindANotary from '@/views/FindANotary'

// import Notaries from '@/views/Notaries'
const Home = () => import('@/views/Home')
const About = () => import('@/views/About')
const Services = () => import('@/views/Services')
const Contact = () => import('@/views/Contact')
const Wildcard = () => import('@/views/Wildcard')
const NotariesTemplate = () => import('@/views/NotariesTemplate')
const NotariesAll = () => import('@/views/NotariesAll')
const NotariesCity = () => import('@/views/NotariesCity')
const NotariesProvince = () => import('@/views/NotariesProvince')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/about',
      name: 'About',
      component: About
    }, {
      path: '/services',
      name: 'Services',
      component: Services
    }, {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }, {
      path: '/notaries',
      component: NotariesTemplate,
      children: [
        {
          path: '',
          name: 'NotariesAll',
          component: NotariesAll
        }, {
          path: ':province',
          name: 'NotariesProvince',
          component: NotariesProvince
        }, {
          path: ':province/:city',
          name: 'NotariesCity',
          component: NotariesCity
        }
      ]
    }, {
      path: '*',
      name: 'Wildcard',
      component: Wildcard
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js